import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import { formSettings } from './../settings';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../../../text/messages';
import WizardButtons from '../../../../../../components/wizard/navigator/buttons';
import { getAdmin, setProgressionProperties } from '../../../../../../reducers/onboarding';
import { getSignatures, sign } from '../../../../../../reducers/signatures';
import { Signatures } from '../../../../../../utilities/signatureTypes';
import mixpanel from 'mixpanel-browser';
class InsuranceAndBenefitsStep extends React.Component {
    constructor(props) {
        super(props);

        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        mixpanel.track('WorkerOnboarding', { _data: { branch: 'employee', step: 'InsuranceAndBenefitsStep' } });

        const { role, admin, client, job, getAdmin, getSignatures, setProgressionProperties } = this.props;
        getSignatures(role, signaturesResult =>
            setProgressionProperties({
                insuranceAndBenefitsAgreement: signaturesResult.find(s => s.name === `${Signatures.types.INSURANCE_AND_BENEFITS.name}:${job.id}`) !== undefined
            })
        );

        if (!admin) {
            getAdmin(client.admin_id);
        }
    }

    submit(values, action) {
        const { role, job, progression, sign, setProgressionProperties } = this.props;
        const { insuranceAndBenefitsAgreement } = progression;
        if (insuranceAndBenefitsAgreement === true) {
            action();
        } else {
            sign(role, `${Signatures.types.INSURANCE_AND_BENEFITS.name}:${job.id}`, () => {
                setProgressionProperties({ insuranceAndBenefitsAgreement: true });
                action();
            });
        }
    }

    render() {
        const { handleSubmit, onSubmit, back, submitting, admin, progression } = this.props;
        if (!admin || !progression || progression.insuranceAndBenefitsAgreement === undefined) {
            return null;
        }

        return (
            <div>
                <div className="row section">
                    <div className="col-xs-12">
                        <FormattedMessage
                            id={'insuranceAndBenefits.intro1'}
                            defaultMessage={'As a W-2 employee of {employer}, you may be eligible for insurance coverage and other employee benefits.'}
                            tagName={'h5'}
                            values={{ employer: admin.employer }}
                        />
                        <FormattedMessage
                            id={'insuranceAndBenefits.intro2'}
                            defaultMessage={
                                "Eligibility begins 60 days after the start of your employment. We'll be in touch with details about a month before that."
                            }
                            values={{ admin: admin.name }}
                        />
                    </div>
                </div>
                <form onSubmit={handleSubmit(values => this.submit(values, onSubmit))}>
                    <WizardButtons disabled={submitting} back={{ action: back }} submit={{ message: <FormattedMessage {...messages.continue} /> }} />
                </form>
            </div>
        );
    }
}

InsuranceAndBenefitsStep = reduxForm(formSettings)(InsuranceAndBenefitsStep);

const mapStateToProps = state => {
    let progression = state.onboarding.progression;
    return {
        role: state.identity.role,
        job: state.onboarding.job,
        admin: state.onboarding.admin,
        client: state.onboarding.client,
        progression,
        initialValues: {
            insuranceAndBenefitsAgreement: progression.insuranceAndBenefitsAgreement
        }
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getAdmin: getAdmin,
            getSignatures: getSignatures,
            sign: sign,
            setProgressionProperties: setProgressionProperties
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(InsuranceAndBenefitsStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/employee/insuranceAndBenefits.jsx